(function (global) {
    "use strict";

    var LOG_PREFIX = "[STOCKED-DELIVERY-PORTAL]";
    function log() { try { console.log.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch (e) { } }
    function warn() { try { console.warn.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch (e) { } }

    var PORTAL_UI_HTML = `
        <div data-binaery-ui="portal-ddp" class="binaery-portal-ddp" style="margin-bottom: 1rem; padding: 1rem; border: 1px solid #e5e7eb; border-radius: 0.75rem; background: #ffffff;">
        <div data-binaery-label="next-delivery" style="font-size: 0.875rem; font-weight: 600; margin-bottom: 0.5rem; color: #111827;">Next delivery: —</div>
        <button type="button" data-binaery-btn="delivery-date" style="width: 100%; padding: 0.625rem 1rem; background: #000000; color: #ffffff; border: none; border-radius: 0.5rem; cursor: pointer; font-weight: 600; font-size: 0.875rem; transition: opacity 0.2s;">Choose delivery date</button>
        </div>
`;

    var CALENDAR_HTML = `
  <div class="binaery-overlay" data-binaery-role="overlay" style="display:none;">
    <div class="binaery-modal">
      <button type="button" class="binaery-modal-close" data-binaery-role="close" aria-label="Close">&times;</button>
      <div class="binaery-modal-body">
        <div class="binaery-modal-calendar" data-binaery-role="calendar-host">
          <div class="binaery-calendar">
            <div class="binaery-calendar-header">
              <button type="button" class="binaery-calendar-nav" data-binaery-role="prev" aria-label="Previous month">‹</button>
              <div class="binaery-calendar-month" data-binaery-role="month-label"></div>
              <button type="button" class="binaery-calendar-nav" data-binaery-role="next" aria-label="Next month">›</button>
            </div>
            <div class="binaery-calendar-weekdays" data-binaery-role="weekday-row">
              <div class="binaery-calendar-weekday"></div>
              <div class="binaery-calendar-weekday"></div>
              <div class="binaery-calendar-weekday"></div>
              <div class="binaery-calendar-weekday"></div>
              <div class="binaery-calendar-weekday"></div>
              <div class="binaery-calendar-weekday"></div>
              <div class="binaery-calendar-weekday"></div>
            </div>
            <div class="binaery-calendar-grid" data-binaery-role="day-grid">
              <button type="button" class="binaery-calendar-cell" data-day-index="0"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="1"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="2"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="3"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="4"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="5"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="6"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="7"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="8"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="9"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="10"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="11"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="12"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="13"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="14"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="15"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="16"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="17"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="18"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="19"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="20"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="21"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="22"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="23"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="24"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="25"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="26"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="27"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="28"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="29"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="30"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="31"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="32"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="33"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="34"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="35"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="36"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="37"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="38"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="39"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="40"></button>
              <button type="button" class="binaery-calendar-cell" data-day-index="41"></button>
            </div>
          </div>
        </div>
        <div class="binaery-modal-actions" style="display: flex; gap: 0.75rem; margin-top: 1rem;">
          <button type="button" class="binaery-ddp-btn" data-binaery-role="cancel" style="flex: 1;">Cancel</button>
          <button type="button" class="binaery-ddp-btn binaery-ddp-btn--primary" data-binaery-role="save" style="flex: 1; background: #000; color: #fff;">Save date</button>
        </div>
      </div>
    </div>
  </div>
`;

    function qs(sel, root) { return (root || document).querySelector(sel); }
    function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

    function readCfg() {
        var node = document.getElementById("binaery-portal-config");
        var cfg = {
            updateEndpoint: "https://stockedfood.eqserver.net/skio/updateSubscriptionDate",
            batchEndpoint: "https://stockedfood.eqserver.net/skio/getSubscriptionsBatch",
            firstDay: 1,
            label: "Choose delivery date",
            shop: "stockedfood.myshopify.com"
        };

        if (!node) return cfg;

        if (node.dataset.updateEndpoint) cfg.updateEndpoint = node.dataset.updateEndpoint;
        if (node.dataset.batchEndpoint) cfg.batchEndpoint = node.dataset.batchEndpoint;
        if (node.dataset.label) cfg.label = node.dataset.label;
        if (node.dataset.firstDay) cfg.firstDay = parseInt(node.dataset.firstDay, 10) || 1;
        if (node.dataset.shop) cfg.shop = node.dataset.shop;

        return cfg;
    }

    var cfg = global.BINAERY_PORTAL_CFG || readCfg();
    log("INIT cfg", cfg);

    var rafScanId = null;
    var observer = null;
    var subscriptionDataCache = {};
    var isFetchingBatch = false;

    function inPortal() {
        var p = (global.location && global.location.pathname) || "";
        return p.indexOf("/a/") === 0;
    }

    function isSubscriptionsPage() {
        var p = (global.location && global.location.pathname) || "";
        return p.indexOf("/a/account/subscriptions") === 0;
    }

    function ensureCalendarLoaded() {
        return !!(global.BinaeryCalendar && typeof global.BinaeryCalendar.initOverlay === "function");
    }

    function getSubscriptionIdFromCard(card) {
        var v =
            card.getAttribute("data-subscription-id") ||
            (card.dataset && (card.dataset.subscriptionId || card.dataset.subId)) ||
            "";

        if (v) return v;

        var inner = qs("[data-subscription-id]", card);
        if (inner) return inner.getAttribute("data-subscription-id") || "";

        return "";
    }

    function normalizeISO(x) {
        if (!x) return "";
        var s = String(x).trim();
        if (s.length >= 10 && s.charAt(4) === "-" && s.charAt(7) === "-") return s.slice(0, 10);
        return s;
    }

    function isoToDDMMYYYY(iso) {
        if (!iso) return "";
        var p = String(iso).slice(0, 10).split("-");
        if (p.length !== 3) return "";
        var pad = function(n) { return String(n).length < 2 ? "0" + n : n; };
        return pad(p[2]) + "." + pad(p[1]) + "." + p[0];
    }

    function ddmmToIso(str) {
        if (!str) return "";
        var p = str.trim().split(".");
        if (p.length !== 3) return "";
        // DD.MM.YYYY -> YYYY-MM-DD
        return p[2] + "-" + p[1] + "-" + p[0];
    }

    function parseSkioDate(str) {
        if (!str) return "";
        var d = new Date(str);
        if (isNaN(d.getTime())) {
            if (str.split(" ").length === 2) {
                var year = new Date().getFullYear();
                d = new Date(str + " " + year);
            }
            if (isNaN(d.getTime())) return "";
        }
        var y = d.getFullYear();
        var m = (d.getMonth() + 1).toString().padStart(2, "0");
        var day = d.getDate().toString().padStart(2, "0");
        return y + "-" + m + "-" + day;
    }

    function extractDateFromCard(card) {
        var dateEl = qs('[data-testid="NextChargeDate"]', card) || 
                     qs('[data-testid="NextRenewalDate"]', card) ||
                     qs('.skio-next-billing-date', card);
        
        if (dateEl) {
            var dateStr = dateEl.textContent.trim();
            log("Extracted date string from DOM:", dateStr);
            return parseSkioDate(dateStr);
        }
        
        return "";
    }

    function getUiTemplateRoot() {
        var wrap = document.getElementById("binaery-portal-ui-template");
        if (wrap && wrap.firstElementChild) return wrap.firstElementChild;
        
        var div = document.createElement("div");
        div.innerHTML = PORTAL_UI_HTML.trim();
        return div.firstElementChild;
    }

    function cardHasUi(card) {
        return !!qs('[data-binaery-ui="portal-ddp"]', card);
    }

    function isCancelled(card) {
        return !!qs('[data-chipname="cancelled"]', card);
    }

    function cloneUi() {
        var root = getUiTemplateRoot();
        if (!root) return null;
        
        var ui = root.cloneNode(true);

        var btn = qs('[data-binaery-btn="delivery-date"]', ui);
        if (btn) btn.textContent = cfg.label || "Choose delivery date";

        return ui;
    }

    function setNextDeliveryLabel(uiRoot, iso) {
        var label = qs('[data-binaery-label="next-delivery"]', uiRoot);
        if (!label) return;

        var formatted = isoToDDMMYYYY(normalizeISO(iso));
        label.textContent = "Next delivery: " + (formatted || "—");
    }

    function toggleLoading(show) {
        var id = "binaery-portal-loading-overlay";
        var el = document.getElementById(id);
        if (show) {
            if (!el) {
                el = document.createElement("div");
                el.id = id;
                el.style = "position:fixed; inset:0; background:rgba(255,255,255,0.7); z-index:2147483647; display:flex; align-items:center; justify-content:center; backdrop-filter:blur(2px);";
                el.innerHTML = '<div style="width:40px; height:40px; border:4px solid #f3f3f3; border-top:4px solid #000; border-radius:50%; animation: binaery-spin 1s linear infinite;"></div><style>@keyframes binaery-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }</style>';
                document.body.appendChild(el);
            }
            el.style.display = "flex";
        } else if (el) {
            el.style.display = "none";
        }
    }

    function formatSkioPaymentDate(date) {
        var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return months[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
    }

    function getSundayBefore(iso) {
        var d = new Date(iso);
        var day = d.getDay(); // 0 = Sun, 1 = Mon ...
        // Sunday before (or same day if already Sunday)
        d.setDate(d.getDate() - day);
        return d;
    }

    function updatePaymentDateLabel(card, deliveryIso) {
        var sunday = getSundayBefore(deliveryIso);
        var formattedShort = formatSkioPaymentDate(sunday);
        
        var chip = qs('[data-testid="chip"]', card);
        if (chip) {
            // Update aria-label: Shipment 2026-06-07T00:00:00+00:00
            // Using a simple ISO string for the aria-label
            var y = sunday.getFullYear();
            var m = (sunday.getMonth() + 1).toString().padStart(2, "0");
            var day = sunday.getDate().toString().padStart(2, "0");
            var isoStr = y + "-" + m + "-" + day + "T00:00:00+00:00";
            chip.setAttribute("aria-label", "Shipment " + isoStr);
            
            // The text is usually inside span > span > span
            var dateSpan = qs('span[title]', chip);
            if (dateSpan) {
                dateSpan.textContent = formattedShort;
                dateSpan.setAttribute("title", formattedShort + " (Asia/Calcutta) ");
            }
        }
    }

    function showCustomConfirm(dateStr) {
        return new Promise(function (resolve) {
            // Create the overlay container
            var overlay = document.createElement("div");
            overlay.className = "binaery-overlay confirm-modal-overlay";
            overlay.style = "position:fixed; inset:0; background:rgba(0,0,0,0.5); z-index:2147483647; display:flex; align-items:center; justify-content:center; backdrop-filter:blur(3px); font-family: inherit;";

            // Create the modal container
            var modal = document.createElement("div");
            modal.style = "background:#ffffff; border-radius:16px; padding:32px; width:90%; max-width:440px; box-shadow:0 10px 25px rgba(0,0,0,0.15); position:relative; text-align:center; box-sizing:border-box; animation: binaery-fade-in 0.2s ease-out;";

            // Animation style
            var styleTag = document.createElement("style");
            styleTag.textContent = "@keyframes binaery-fade-in { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }";
            document.head.appendChild(styleTag);

            // Close button (x)
            var closeBtn = document.createElement("button");
            closeBtn.style = "position:absolute; top:16px; right:16px; background:#f5f5f5; border:none; border-radius:50%; width:32px; height:32px; cursor:pointer; display:flex; align-items:center; justify-content:center; font-weight:bold; color:#212121; font-size:16px; line-height:1; padding:0; margin:0;";
            closeBtn.innerHTML = "&times;";
            closeBtn.onclick = function () {
                cleanup();
                resolve(false);
            };
            modal.appendChild(closeBtn);

            // Header
            var header = document.createElement("h3");
            header.textContent = "Immediate Payment Confirm";
            header.style = "margin:0 0 16px 0; font-size:18px; font-weight:bold; color:#212121; text-transform:uppercase; letter-spacing:0.5px;";
            modal.appendChild(header);

            // Message text
            var text = document.createElement("p");
            text.innerHTML = "Selecting a delivery date in the current week (<strong>" + dateStr + "</strong>) will trigger payment for this order immediately.<br><br>Are you sure you want to proceed?";
            text.style = "margin:0 0 28px 0; font-size:14px; line-height:1.5; color:#555555; text-align:center;";
            modal.appendChild(text);

            // Buttons Container
            var btnContainer = document.createElement("div");
            btnContainer.style = "display:flex; gap:12px; justify-content:stretch;";

            // Cancel Button
            var cancelBtn = document.createElement("button");
            cancelBtn.textContent = "CANCEL";
            cancelBtn.style = "flex:1; background:#212121; color:#ffffff; border:none; border-radius:8px; padding:12px 16px; font-size:13px; font-weight:bold; cursor:pointer; text-transform:uppercase; transition: background 0.2s;";
            cancelBtn.onmouseenter = function() { cancelBtn.style.background = "#333333"; };
            cancelBtn.onmouseleave = function() { cancelBtn.style.background = "#212121"; };
            cancelBtn.onclick = function () {
                cleanup();
                resolve(false);
            };
            btnContainer.appendChild(cancelBtn);

            // Proceed Button
            var proceedBtn = document.createElement("button");
            proceedBtn.textContent = "SAVE DATE";
            proceedBtn.style = "flex:1; background:#fdbb30; color:#212121; border:none; border-radius:8px; padding:12px 16px; font-size:13px; font-weight:bold; cursor:pointer; text-transform:uppercase; transition: background 0.2s;";
            proceedBtn.onmouseenter = function() { proceedBtn.style.background = "#e5a720"; };
            proceedBtn.onmouseleave = function() { proceedBtn.style.background = "#fdbb30"; };
            proceedBtn.onclick = function () {
                cleanup();
                resolve(true);
            };
            btnContainer.appendChild(proceedBtn);

            modal.appendChild(btnContainer);
            overlay.appendChild(modal);
            document.body.appendChild(overlay);

            function cleanup() {
                overlay.remove();
                styleTag.remove();
            }
        });
    }

    async function updateSubscriptionDate(iso) {
        var ctx = global.__BINAERY_PORTAL_CONTEXT__;
        if (!ctx) return;

        log("Updating subscription date...", iso, ctx);
        toggleLoading(true);

        // Calculate the Sunday of the current week (cutoff Sunday) in UK time
        var ukTodayStr = window.ukToday;
        if (!ukTodayStr) {
            var d = new Date();
            var yy = d.getFullYear();
            var mm = String(d.getMonth() + 1).padStart(2, "0");
            var dd = String(d.getDate()).padStart(2, "0");
            ukTodayStr = yy + "-" + mm + "-" + dd;
        }
        var p = ukTodayStr.split("-").map(function(x) { return parseInt(x, 10); });
        var date = new Date(p[0], p[1] - 1, p[2]);
        var dow = date.getDay(); // 0 = Sun, 1 = Mon ...
        var daysUntilSunday = (7 - dow) % 7;
        date.setDate(date.getDate() + daysUntilSunday);
        
        var yy = date.getFullYear();
        var mm = String(date.getMonth() + 1).padStart(2, "0");
        var dd = String(date.getDate()).padStart(2, "0");
        var cutoffSunday = yy + "-" + mm + "-" + dd;

        var currentIso = ctx.currentIso || "";
        var chargeImmediately = (iso <= cutoffSunday) && (iso !== currentIso);
        log("Cutoff Sunday:", cutoffSunday, "Selected date:", iso, "currentIso:", currentIso, "chargeImmediately:", chargeImmediately);

        if (chargeImmediately) {
            var formattedDate = isoToDDMMYYYY(iso);
            toggleLoading(false);
            var confirmed = await showCustomConfirm(formattedDate);
            if (!confirmed) {
                return;
            }
            toggleLoading(true);
        }

        var payload = {
            shop: cfg.shop,
            subscriptionId: ctx.subscriptionId,
            nextDateISO: iso,
            note: isoToDDMMYYYY(iso),
            chargeImmediately: chargeImmediately
        };

        try {
            var res = await global.fetch(ctx.updateEndpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            var json = await res.json();
            if (json.ok) {
                log("Update successful, updating UI state...");
                
                // Update local cache
                if (subscriptionDataCache[ctx.subscriptionId]) {
                    subscriptionDataCache[ctx.subscriptionId].billing = subscriptionDataCache[ctx.subscriptionId].billing || {};
                    subscriptionDataCache[ctx.subscriptionId].billing.note = isoToDDMMYYYY(iso);
                }

                ctx.currentIso = iso; // Update the context active date

                // Update the labels on the card immediately
                qsa('[data-testid="SubscriptionCard"]').forEach(function (card) {
                    if (getSubscriptionIdFromCard(card) === ctx.subscriptionId) {
                        setNextDeliveryLabel(card, iso);
                        updatePaymentDateLabel(card, iso);
                    }
                });

                // Close the calendar modal
                var overlay = qs('.binaery-overlay[data-binaery-role="overlay"]');
                if (overlay) overlay.remove();

                // Optional: show a small toast or reload
                if (chargeImmediately) {
                    if (typeof toast === "function") toast("Payment triggered and delivery date updated! Reloading...");
                    else alert("Payment triggered and delivery date updated successfully!");
                    setTimeout(function () {
                        global.location.reload();
                    }, 1500);
                } else {
                    if (typeof toast === "function") toast("Delivery date updated!");
                    else log("Delivery date updated successfully!");
                }
            } else {
                // alert("Failed to update: " + (json.message || "Unknown error"));
                warn("Failed to update", json.message);
            }
        } catch (e) {
            warn("Update failed", e);
            // alert("An error occurred while updating the delivery date.");
        } finally {
            toggleLoading(false);
        }
    }

    function hookCalendarSave() {
        if (!global.BinaeryCalendar) {
            setTimeout(hookCalendarSave, 500);
            return;
        }

        if (global.BinaeryCalendar.__PORTAL_HOOKED__) return;
        global.BinaeryCalendar.__PORTAL_HOOKED__ = true;

        var origSetDate = global.BinaeryCalendar.setSelectedDeliveryDate;
        global.BinaeryCalendar.setSelectedDeliveryDate = function (iso) {
            if (global.__BINAERY_PORTAL_CONTEXT__) {
                updateSubscriptionDate(iso);
            } else if (typeof origSetDate === "function") {
                origSetDate(iso);
            }
        };
    }

    function openCalendarOverlay(shop, subscriptionId, rules) {
        if (!ensureCalendarLoaded()) {
            warn("BinaeryCalendar not loaded.");
            return;
        }

        var tpl = document.getElementById("binaery-calendar-template");
        var overlay = null;

        if (tpl) {
            overlay = (tpl.content && tpl.content.firstElementChild)
                ? tpl.content.firstElementChild.cloneNode(true)
                : tpl.firstElementChild.cloneNode(true);
        } else {
            var div = document.createElement("div");
            div.innerHTML = CALENDAR_HTML.trim();
            overlay = div.firstElementChild;
        }

        if (!overlay) {
            warn("Could not create calendar overlay.");
            return;
        }

        overlay.style.display = "flex";
        document.body.appendChild(overlay);

        global.BinaeryCalendar.initOverlay(overlay, cfg, rules || {});

        overlay.addEventListener("click", function (e) {
            if (e.target === overlay) overlay.remove();
        });
    }

    function injectIntoCard(card) {
        if (cardHasUi(card) || isCancelled(card) || card.dataset.binaeryInjecting === "1") return;
        card.dataset.binaeryInjecting = "1";

        var subscriptionId = getSubscriptionIdFromCard(card);
        var shop = cfg.shop || (global.Shopify && global.Shopify.shop);

        if (!subscriptionId || !shop) {
            card.dataset.binaeryInjecting = "0";
            return;
        }

        var baseRules = global.BinaeryRulesData || {
            disabledWeekdays: [0, 1, 2, 6],
            disabledDates: [],
            disabledRanges: []
        };

        var rules = JSON.parse(JSON.stringify(baseRules));
        rules.isSkioPortal = true;
        
        // Get delivery date from batch data or DOM
        var currentIso = "";
        var subData = subscriptionDataCache[subscriptionId];
        if (subData && subData.billing && subData.billing.note) {
            currentIso = ddmmToIso(subData.billing.note);
            log("Using date from batch API:", subData.billing.note, "->", currentIso);
        } else {
            currentIso = extractDateFromCard(card);
            log("Using date from DOM extraction:", currentIso);
        }

        if (currentIso) {
            rules.currentDeliveryDate = currentIso;
        }

        var ui = cloneUi();
        if (!ui) {
            card.dataset.binaeryInjecting = "0";
            return;
        }

        setNextDeliveryLabel(ui, currentIso);

        var btn = qs('[data-binaery-btn="delivery-date"]', ui);
        if (btn) {
            btn.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();

                global.__BINAERY_PORTAL_CONTEXT__ = {
                    shop: shop,
                    subscriptionId: subscriptionId,
                    updateEndpoint: cfg.updateEndpoint,
                    currentIso: currentIso
                };

                openCalendarOverlay(shop, subscriptionId, rules);
            });
        }

        card.prepend(ui);
        card.dataset.binaeryInjecting = "0";
    }

    async function fetchSubscriptionBatch(ids) {
        if (!ids.length) return null;
        try {
            var res = await global.fetch(cfg.batchEndpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ subscriptionIds: ids })
            });
            var json = await res.json();
            return json.ok ? json.subscriptions : null;
        } catch (e) {
            warn("Batch fetch failed", e);
            return null;
        }
    }

    async function scan() {
        if (!inPortal() || !isSubscriptionsPage() || isFetchingBatch) return;
        
        var cards = qsa('[data-testid="SubscriptionCard"]');
        if (!cards.length) return;

        var idsToFetch = [];
        cards.forEach(function(card) {
            if (cardHasUi(card) || isCancelled(card)) return;
            var id = getSubscriptionIdFromCard(card);
            if (id && !subscriptionDataCache[id]) {
                idsToFetch.push(id);
            }
        });

        if (idsToFetch.length) {
            isFetchingBatch = true;
            log("Fetching batch data for IDs:", idsToFetch);
            var subs = await fetchSubscriptionBatch(idsToFetch);
            if (subs) {
                subs.forEach(function(sub) {
                    subscriptionDataCache[sub.id] = sub;
                });
            }
            isFetchingBatch = false;
        }

        cards.forEach(injectIntoCard);
    }

    function scheduleScan() {
        if (rafScanId) return;
        rafScanId = global.requestAnimationFrame(function () {
            rafScanId = null;
            scan();
        });
    }

    function startObserver() {
        if (observer) return;
        observer = new MutationObserver(scheduleScan);
        observer.observe(document.body, { childList: true, subtree: true });
    }

    function boot() {
        hookCalendarSave();
        startObserver();
        scheduleScan();
        setTimeout(scheduleScan, 500);
        setTimeout(scheduleScan, 1500);
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
    else boot();

})(window);
